/**
 * Pick of the Day Component
 */

import { useState, useEffect } from '@wordpress/element';
import { useFilms } from '../context/FilmContext';
import AlertButton from './AlertButton';
import dayjs from 'dayjs';

export default function PickOfDay() {
    const { fetchPickOfDay, loading } = useFilms();
    const [data, setData] = useState(null);

    const t = window.rialtoData?.translations || {};

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        const result = await fetchPickOfDay();
        setData(result);
    };

    if (loading && !data) {
        return (
            <div className="rialto-loading">
                <div className="rialto-spinner"></div>
            </div>
        );
    }

    if (!data?.pick) {
        return null;
    }

    const { pick } = data;
    const film = pick.film;

    return (
        <div className="rialto-pick rialto-pick-of-day">
            {film.poster && (
                <div className="rialto-pick-bg">
                    <img src={film.poster} alt="" />
                </div>
            )}

            <div className="rialto-pick-content">
                <div className="rialto-pick-poster">
                    <img src={film.poster || film.poster_thumb} alt={film.title} />
                </div>

                <div className="rialto-pick-info">
                    <span className="rialto-pick-label">
                        {t.pickOfDay || 'Pick of the Day'}
                    </span>

                    <h2 className="rialto-pick-title">{film.title}</h2>

                    <div className="rialto-pick-meta">
                        {film.year && <span>{film.year}</span>}
                        {film.genres?.length > 0 && <span> | {film.genres.join(', ')}</span>}
                        {film.duration && <span> | {film.duration} {t.minutes || 'min'}</span>}
                        {film.certification && (
                            <span className="rialto-cert">{film.certification}</span>
                        )}
                    </div>

                    {film.synopsis && (
                        <p className="rialto-pick-synopsis">{film.synopsis}</p>
                    )}

                    <div className="rialto-pick-time">
                        {t.tonightAt || 'Tonight at'} {pick.time}
                    </div>

                    <div className="rialto-pick-actions">
                        <AlertButton
                            screeningId={pick.screening_id}
                            filmTitle={film.title}
                            screeningTime={pick.datetime}
                        />

                        {film.youtube_trailer && (
                            <a
                                href={film.youtube_trailer}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="rialto-btn rialto-btn-secondary"
                            >
                                {t.watchTrailer || 'Watch Trailer'}
                            </a>
                        )}

                        <a href={film.url} className="rialto-btn rialto-btn-secondary">
                            {t.moreInfo || 'More Info'}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
